export interface PrepaidCardNote {
    title: string;
    /** 항목 안 줄바꿈은 \n 으로 표기한다. */
    items: string[];
}

export type PrepaidCardNoteType = 'USAGE' | 'REFUND';

export const PREPAID_CARD_USAGE_NOTE: PrepaidCardNote = {
    title: '선불카드 유의사항',
    items: [
        '본 디지털 상품권은 현금과 교환되지 않습니다.',
        '타 쿠폰 중복사용이나 포인트 적립 및 제휴카드 할인은 브랜드사 정책에 따릅니다.',
        '사용여부 및 잔액관련 문의는 고객센터 1대1 문의 남기기 또는 카카오톡채널(ID: 발트루스트)에서 확인 가능합니다.\n* 운영시간: 평일 10:00 ~ 17:00 (주말 및 공휴일 상담 불가)',
        '환불, 교환, 승인에 대한 문의는 상품권 구매처에 문의해 주시기 바랍니다.',
    ],
};

export const PREPAID_CARD_REFUND_NOTE: PrepaidCardNote = {
    title: '잔액환불규정',
    items: [
        '구매일로부터 5년 이내 사용 후 남은 잔액에 대해 환불 신청 가능합니다.',
        '1만원 이하 상품권은 80% 이상 사용 시 환불 가능하며, 1만원 초과 상품권은 60% 이상 사용 시 환불 가능합니다.',
        '사용처에서는 잔액환불이 불가하며, 고객센터 1대1 문의 남기기 또는 카카오톡채널(ID: 발트루스트)을 통해 잔액 환불 문의 가능합니다.',
    ],
};

export const ENCOFFEE_PREPAID_CARD_USAGE_NOTE: PrepaidCardNote = {
    title: '유의사항',
    items: [
        '엔커피 카드는 모바일 앱에서만 구입이 가능합니다.',
        '구입하신 엔커피 카드의 충전은 모바일 앱에서 가능합니다.',
        '엔커피 카드는 매장에서 현금으로 교환되지 않으며, 별도로 거래될 수 없습니다.',
        '엔커피 카드로 결제 시 적립이 불가한 상품은 다음과 같습니다.\n* 디저트, RTD, MD 상품',
        '1회 최대 100,000원까지 충전이 가능합니다.',
    ],
};

export const ENCOFFEE_PREPAID_CARD_REFUND_NOTE: PrepaidCardNote = {
    title: '잔액 환불 규정',
    items: [
        '구매일로부터 5년 이내 사용 후 남은 잔액에 한하여 환불 신청이 가능합니다.',
        '최초 유효기간은 결제 후 일주일입니다.',
        '마지막 충전금액으로부터 60% 이상 사용 시 환불 신청이 가능합니다.',
        '최초 유효기간 이내에는 환불 신청 금액의 100% 환불이 가능합니다.',
        '매장에서는 잔액 환불이 불가합니다. 환불 관련 문의는 고객센터 1:1 문의 남기기 또는 카카오톡 채널(ID: 발트루스트)로 문의해주세요.\n* 운영시간: 평일 10:00~17:00\n* 점심시간: 12:00~13:00\n* 주말 및 공휴일 휴무',
    ],
};

export const PREPAID_CARD_NOTES: Record<PrepaidCardNoteType, PrepaidCardNote> = {
    USAGE: PREPAID_CARD_USAGE_NOTE,
    REFUND: PREPAID_CARD_REFUND_NOTE,
};

export const ENCOFFEE_PREPAID_CARD_NOTES: Record<PrepaidCardNoteType, PrepaidCardNote> = {
    USAGE: ENCOFFEE_PREPAID_CARD_USAGE_NOTE,
    REFUND: ENCOFFEE_PREPAID_CARD_REFUND_NOTE,
};
